import { Injectable } from '@angular/core';
import { DetachedRouteHandle } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class RouteReuseService {
  private routesToPreserve = new Set<string>();
  private storedHandles = new Map<string, DetachedRouteHandle>();

  markForReuse(path: string): void {
    this.routesToPreserve.add(path);
  }

  unmarkForReuse(path: string): void {
    this.routesToPreserve.delete(path);
    this.storedHandles.delete(path);
  }

  shouldPreserve(path: string): boolean {
    return this.routesToPreserve.has(path);
  }

  storeHandle(path: string, handle: DetachedRouteHandle | null): void {
    if (handle) {
      this.storedHandles.set(path, handle);
    } else {
      this.storedHandles.delete(path);
    }
  }

  getHandle(path: string): DetachedRouteHandle | null {
    return this.storedHandles.get(path) || null;
  }

  hasStoredHandle(path: string): boolean {
    return this.storedHandles.has(path);
  }

  onReattach(path: string, callback: () => void): void {
    this.reattachCallbacks.set(path, callback);
  }

  notifyReattach(path: string): void {
    const callback = this.reattachCallbacks.get(path);
    if (callback) {
      this.reattachCallbacks.delete(path);
      callback();
    }
  }

  private reattachCallbacks = new Map<string, () => void>();
  private reattachingPaths = new Set<string>();

  markAsReattaching(path: string): void {
    this.reattachingPaths.add(path);
  }

  consumeReattaching(path: string): boolean {
    return this.reattachingPaths.delete(path);
  }
}
